<template>
  <div class="post-page">
    <div class="post-main">
      <div class="post-content">
        <div v-if="operationType != 'add'" class="user-info">
          <div class="avatar">
            <img :src="resourceUrl(postObj.userAvatar,'avatar')">
          </div>
          <div class="username-time">
            <div class="username">{{postObj.nickName}}</div>
            <div class="time">{{ postObj.createTime }}</div>
          </div>
        </div>
        <div v-else class="user-info">
          <div class="avatar">
            <img :src="resourceUrl(getAvatar,'avatar')">
          </div>
          <div class="username-time">
            <div class="username">{{$store.getters.nickName}}</div>
            <div class="time">{{ currentTime }}</div>
          </div>
        </div>
        <div class="post-area">
          <template v-if="checkFlag">
            {{postObj.content}}
          </template>
          <template v-else>
            <el-input type="textarea" v-model="postObj.content" :rows="6"></el-input>
          </template>
        </div>
        <div class="img-area" v-if="postObj.accessoryList && postObj.accessoryList.length > 0">
          <template v-for="(accessory,index) in postObj.accessoryList">
            <div class="img" :key="index">
              <img :src="resourceUrl(accessory.url)">
            </div>
          </template>
        </div>
        <div class="detail" v-if="checkFlag">
          <div class="like" @click="likeClick">
            <i class="iconfont icon-pinglun"><img src="@/static/icon/appreciate.svg"></i>
            <span>{{ postObj.likeNum }}</span>
          </div>
          <div class="messge">
            <i class="iconfont icon-pinglun"><img src="@/static/icon/message.svg"></i>
            <span>{{ postObj.messageNum }}</span>
          </div>
        </div>
        <div class="foot" v-if="!checkFlag">
          <div class="upload" >
            <el-upload
                ref="titleUpload"
                :action="baseUrl + '/common/upload'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
            >
            <span>
              <img src="@/static/icon/pic.svg">
            </span>
            </el-upload>
          </div>
          <div class="save" @click="saveClick">
            保存
          </div>
        </div>
      </div>
      <div v-if="operationType != 'add'" class="comment">
        <h-comment :business-id="postObj.id" :type="'2'" :row="3" @success="commentAdd"></h-comment>
        <h-comment-list :comment-list="postObj.commentList"></h-comment-list>
      </div>

    </div>
  </div>

</template>

<script>
import 'mavon-editor/dist/css/index.css'
import HFloatIcon from '@/page/components/h-float-icon'
import { gePostById, hasPermiCheck, savePost } from '@/api/postApi'
import HComment from '@/page/components/h-comment'
import { commentAdd } from '@/api/commentApi'
import HCommentList from '@/page/components/h-comment-list'
import { likeAdd } from '@/api/likeApi'

export default {
  name: 'index',
  components: { HCommentList, HComment,  HFloatIcon, },
  data() {
    return {
      operationType: '',
      postObj: {},
      baseUrl: process.env.VUE_APP_BASE_API,
    }
  },
  computed: {
    getAvatar(){
      return this.$store.getters.avatar;
    },
    currentTime() {
      return new Date().toLocaleString();
    },
    checkFlag(){
      return !this.operationType || this.operationType == 'check';
    }
  },
  mounted() {
    this.init();
  },
  watch:{
    '$route.query.postId'(newValue, oldValue) {
      if(newValue != oldValue){
        this.init();
      }
    }
  },
  methods: {
    init(){
      const query = this.$route.query;
      if(query.type){
        switch (query.type){
          case 'add':
          case 'edit':
            this.hasPermiCheck(query);
            break
          case 'check':
            this.operationType = query.type;
            this.getInfo(query.postId);
            break
        }
      }else {
        //查看
        this.getInfo(query.postId);
      }

    },
    hasPermiCheck(query){
      const $this = this;
      if(query.type == 'add'){
        $this.postObj = {};
        $this.operationType = query.type;
      }else {
        hasPermiCheck({id:$this.postObj.id}).then(res=>{
          if(res.data){
            //有权限
            $this.operationType = query.type;
          }else {
            //没有权限
            this.$router.push({ path: '/401'});
          }
        })
      }
    },
    getInfo(id){
      const $this = this;
      gePostById(id).then(res =>{
        if(res && res.code == 200){
          $this.postObj = res.data;
        }
      })
    },
    handleAvatarSuccess(res, file){
      if(!this.postObj.accessoryList){
        this.postObj.accessoryList = [];
      }
      this.postObj.accessoryList.push({url:res.fileName})
      this.$forceUpdate();
    },
    saveClick(){
      const $this = this;
      savePost(this.postObj).then(res =>{
        if(res && res.code == 200){
          this.$message.success("保存成功");
          let params = {};
          params.postId = res.data.id;
          params.type = 'check';
          $this.postObj = res.data;
          $this.$router.push({ path: '/post',query:params});
        }
      })
    },
    commentAdd(content,businessId){
      this.init();
    },
    likeClick(){
      let like = {};
      like.type = '2';
      like.businessId = this.postObj.id;
      likeAdd(like).then(res =>{
        if(res){
          if(res.code == 200){
            this.postObj.likeNum ++;
            this.$message.success("点赞成功");
          }else if(res.code == 401){
            this.$message.warning("请登录");
          }
        }else {
          this.$message.warning("已经点过赞啦");
        }
      })
    }
  },


}
</script>

<style scoped>
@import '../../static/css/post.css';

</style>
